query ApplicationForApplicationConsole(
    $domain: String!
) {
    application(
        domain: $domain
    ) {
        id
        domain

        name
        about {
            language
            text
        }

        country

        brandIDs
        colors {
            accent {
                ...ApplicationColor
            }
            primary {
                ...ApplicationColor
            }
            secondary {
                ...ApplicationColor
            }
            tertiary {
                ...ApplicationColor
            }
        }
        favicon
        logo
        coverImage

        instanceSpecification {
            ...SpecificationConfiguration
        }
        typeSpecification {
            ...SpecificationConfiguration
        }

        features
    }
}

fragment ApplicationColor on ApplicationColor {
    contrastText
    dark
    light
    main
}

fragment SpecificationConfiguration on SpecificationConfiguration {
    bimClassIDs
    customSpecification
    realSpecification
    rootCategoryID
}
